import React from 'react';
import Image from '../../../components/AppImage';

const ArticleContent = ({ content, embeddedImages }) => {
  const renderContent = () => {
    const sections = content?.split('\n\n');
    
    return sections?.map((section, index) => {
      if (section?.startsWith('# ')) {
        return (
          <h2 key={index} className="text-xl font-semibold text-foreground mt-8 md:mt-10 lg:mt-12 mb-4 md:mb-5 lg:mb-6">
            {section?.replace('# ', '')}
          </h2>
        );
      }
      
      if (section?.startsWith('## ')) {
        return (
          <h3 key={index} className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground mt-6 md:mt-7 lg:mt-8 mb-3 md:mb-4 lg:mb-5">
            {section?.replace('## ', '')}
          </h3>
        );
      }
      
      if (section?.startsWith('### ')) {
        return (
          <h4 key={index} className="text-base md:text-lg lg:text-xl font-semibold text-foreground mt-5 md:mt-6 lg:mt-7 mb-3 md:mb-4">
            {section?.replace('### ', '')}
          </h4>
        );
      }
      
      if (section?.startsWith('```')) {
        const codeContent = section?.replace(/```[\w]*\n?/g, '')?.trim();
        return (
          <pre key={index} className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 overflow-x-auto my-6 md:my-7 lg:my-8">
            <code className="text-sm md:text-base text-foreground font-mono">
              {codeContent}
            </code>
          </pre>
        );
      }
      
      if (section?.startsWith('- ') || section?.startsWith('* ')) {
        const items = section?.split('\n')?.filter(item => item?.trim());
        return (
          <ul key={index} className="space-y-2 md:space-y-3 my-4 md:my-5 lg:my-6 ml-4 md:ml-5 lg:ml-6">
            {items?.map((item, itemIndex) => (
              <li key={itemIndex} className="text-sm md:text-base lg:text-lg text-muted-foreground leading-relaxed list-disc">
                {item?.replace(/^[-*]\s/, '')}
              </li>
            ))}
          </ul>
        );
      }
      
      if (section?.match(/^\d+\.\s/)) {
        const items = section?.split('\n')?.filter(item => item?.trim());
        return (
          <ol key={index} className="space-y-2 md:space-y-3 my-4 md:my-5 lg:my-6 ml-4 md:ml-5 lg:ml-6 list-decimal">
            {items?.map((item, itemIndex) => (
              <li key={itemIndex} className="text-sm md:text-base lg:text-lg text-muted-foreground leading-relaxed">
                {item?.replace(/^\d+\.\s/, '')}
              </li>
            ))}
          </ol>
        );
      }
      
      if (section?.startsWith('[IMAGE:')) {
        const imageIndex = parseInt(section?.match(/\[IMAGE:(\d+)\]/)?.[1] || '0');
        const imageData = embeddedImages?.[imageIndex];
        
        if (imageData) {
          return (
            <figure key={index} className="my-6 md:my-8 lg:my-10">
              <div className="relative w-full h-64 md:h-80 lg:h-96 overflow-hidden rounded-lg">
                <Image
                  src={imageData?.url}
                  alt={imageData?.alt}
                  className="w-full h-full object-cover"
                />
              </div>
              {imageData?.caption && (
                <figcaption className="mt-3 md:mt-4 text-sm md:text-base text-muted-foreground text-center">
                  {imageData?.caption}
                </figcaption>
              )}
            </figure>
          );
        }
      }
      
      if (section?.trim()) {
        return (
          <p key={index} className="text-sm md:text-base lg:text-lg text-muted-foreground leading-relaxed my-4 md:my-5 lg:my-6">
            {section}
          </p>
        );
      }
      
      return null;
    });
  };

  return (
    <article className="prose prose-invert max-w-none">
      {renderContent()}
    </article>
  );
};

export default ArticleContent;